/** Guest surface path prefix: `/restaurants` or `/kiosk` */
export type GuestPathPrefix = 'restaurants' | 'kiosk';

export function guestPathPrefixFromPathname(pathname: string): GuestPathPrefix {
  return pathname.startsWith('/kiosk/') ? 'kiosk' : 'restaurants';
}

export function guestBasePath(appName: string, prefix: GuestPathPrefix = 'restaurants'): string {
  return `/${prefix}/${appName}`;
}

/** Pages where the ongoing-order bar is shown while browsing after placing an order */
export function shouldShowOngoingOrderBar(pathname: string): boolean {
  if (pathname.startsWith('/kiosk/')) {
    return false;
  }
  const match = pathname.match(/^\/(?:restaurants|kiosk)\/([^/]+)(?:\/(.+))?$/);
  if (!match) {
    return false;
  }

  const subPath = match[2];
  if (!subPath) {
    return prefixIsRestaurants(pathname);
  }

  if (subPath === 'menu' || subPath === 'cart' || subPath === 'browse') {
    return true;
  }

  return subPath.startsWith('menu/');
}

function prefixIsRestaurants(pathname: string): boolean {
  return pathname.startsWith('/restaurants/');
}

export function extractAppNameFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/(?:restaurants|kiosk)\/([^/]+)/);
  return match ? match[1] : null;
}

/** Order id from `/restaurants|kiosk/:appName/orders/:orderId` */
export function extractOrderIdFromPath(pathname: string): number | null {
  const match = pathname.match(/^\/(?:restaurants|kiosk)\/[^/]+\/orders\/(\d+)/);
  if (!match) return null;
  const id = parseInt(match[1], 10);
  return Number.isNaN(id) ? null : id;
}

/** All customer pages under a restaurant (Peppy AI scope) */
export function isRestaurantCustomerRoute(pathname: string): boolean {
  return /^\/(?:restaurants|kiosk)\/[^/]+/.test(pathname);
}

/** Table reservation page — uses dedicated Peppy booking panel instead of floating widget */
export function isReserveTableRoute(pathname: string): boolean {
  return /^\/restaurants\/[^/]+\/reserve-table\/?$/.test(pathname);
}

export function isKioskRoute(pathname: string): boolean {
  return pathname.startsWith('/kiosk/');
}
